window.Ninja = window.Ninja || {

};

( function() {

  Object.assign( Ninja, {
    version: '1.0.0',
    modules: [],
  } );

  Ninja.modules = {};

  Ninja.ready = function ( fn ) {
    if ( document.readyState !== 'loading' ) { fn(); return; }
    document.addEventListener( 'DOMContentLoaded', fn, { once: true } );
  };

  // Register feature modules (idempotent)
  Ninja.register = function ( name, factory ) {

    if ( Ninja.modules[ name ] ) {
      return Ninja.modules[ name ];
    }

    const api = factory( Ninja );
    Ninja.modules[ name ] = api;
    return api;

  };

} )();
